import React, { useState } from 'react'
import { Switch, Route, Link, useLocation } from 'react-router-dom'

import Home from './Home'
import Suppliers from './suppliers'
import Invoices from './Invoices'
import PurchaseOrders from './lpos'
import Users from './Users'
import CreditNotes from '../Accounts/credit-notes'

const Procurement = () => {
    const location = useLocation()
    const split = location.pathname.split('/')

    const page = split[3]

    let menu = [
        {
            path: '',
            title: 'Dashboard',
            component: <Home />
        },
        {
            path: 'invoices',
            title: 'Invoices',
            component: <Invoices />
        },
        {
            path: 'suppliers',
            title: 'Suppliers',
            component: <Suppliers />
        },
        {
            path: 'purchase-orders',
            title: 'Purchase Orders',
            component: <PurchaseOrders />
        },
        {
            path: 'credit-notes',
            title: 'Credit Notes',
            component: <CreditNotes path="/app/procurement/credit-notes" />
        },
        {
            path: 'requisition-forms',
            title: 'Requisition Forms',
            component: <></>
        },
        {
            path: 'critical-items',
            title: 'Critical Items',
            component: <></>
        }
    ]

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap max-h-full overflow-hidden">
            <div className="w-1/6 overflow-y-scroll">
                <p className="text-2xl font-semibold">Procurement</p>
                <ul className="space-y-2">
                    {
                        menu.map(item => 
                            <li>
                                <Link to={ `/app/procurement/${item.path}` } className={ `flex items-center p-2 text-base font-normal text-gray-900 ${ page === item.path ? 'text-yellow-600 border-l-4 border-yellow-500 h-8' : '' } hover:bg-gray-100` }>{ item.title }</Link>
                            </li>
                        )
                    }
                </ul>
            </div>
            <div className="w-5/6 overflow-y-scroll">
                <Switch>
                    {
                        menu.map(item => 
                            <Route exact={ item.path === '' ? true : false } path={ `/app/procurement/${item.path}` }>
                                { item.component }
                            </Route>
                        )
                    }
                </Switch>
            </div>
        </div>
    )
}

export default Procurement